import { createContext, useCallback, useContext } from "react";
import ReportPreview from "../../components/ReportPreview";
import IReport from "../../interfaces/IReport";
import useState from "../../hooks/useState";


interface IReportPreviewContext {
    handleOpen: (report: IReport, filters: any) => void;
}

interface IStateValues {
    open: boolean;
    selectedReport: IReport | undefined;
    filters: any;
}


const ReportPreviewContext = createContext<IReportPreviewContext | undefined>(undefined);

const ReportPreviewContextProvider = (props: React.PropsWithChildren) => {
    const state = useState<IStateValues>({
        open: false,
        selectedReport: undefined,
        filters: undefined
    });

    const handleOpen = useCallback((report: IReport, filters: any) => {
        state.update('selectedReport', report);
        state.update('filters', filters);
        state.update('open', true);
        // eslint-disable-next-line
    }, []);


    const handleClose = useCallback(() => {
        state.reset();
        // eslint-disable-next-line
    }, []);
    
    
    const data: IReportPreviewContext = {
        handleOpen
    }

    return (
        <ReportPreviewContext.Provider value={data}>
            {props.children}

            <ReportPreview
                open={state.values.open}
                handleClose={handleClose}
                report={state.values.selectedReport}
                filters={state.values.filters}
            />
        </ReportPreviewContext.Provider>
    );
}


const useReportPreviewContext = () => {
    const context = useContext(ReportPreviewContext);

    if (context === undefined) {
        throw new Error('useReportPreviewContext must be used within a ReportPreviewContextProvider');
    }

    return context;
}

export {
    useReportPreviewContext
}

export default ReportPreviewContextProvider;